// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k2Nd6","left":"styles_left__11rfc","desktopActions":"styles_desktopActions__3XTCI","title":"styles_title__1kJYC"};